module.exports = __webpack_public_path__ + "img/LV.fa767e7c.svg";